import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ActionsDropdown, BoxIcon } from "./styled";
// import ConfirmationDelete from "../../../../components/Modal-Confirmation";
import { useState } from "react";
import { toast } from "react-toastify";
// import { FaLayerGroup } from "react-icons/fa";
import IconShopify from "../../../../assets/imgs/icons-integrations/shopify.png";
import IconNuvemshop from "../../../../assets/imgs/icons-integrations/nuvemshop.png";
import IconDropi from "../../../../assets/imgs/icons-integrations/dropi.png";
// import IconSite from "../../../../assets/imgs/site.webp";
import IconYampi from "../../../../assets/imgs/icons-integrations/yampi.png";
// import IconCartpanda from "../../../../assets/imgs/icons-integrations/cartpanda.png";
// import IconLandpage from "../../../../assets/imgs/icons-integrations/landpage.png";
// import IconLojaIntegrada from "../../../../assets/imgs/icons-integrations/loja-integrada.png";
// import IconMontink from "../../../../assets/imgs/icons-integrations/montink.png";
// import { AiOutlineLoading } from "react-icons/ai";
// import { FiCalendar } from "react-icons/fi";
import ModalAddTime from "../modal-add-time";
// import { FiMoreVertical } from "react-icons/fi";
// import { date } from "yup";
import { MdOutlineContentCopy } from "react-icons/md";
import ModalWebhook from "../modal-webhook";

const CardNew = (props) => {

    const statusDebug = useSelector(state => state.reducerAdminDebug)
    const statusAddTime = useSelector(state => state.reducerAdminAddTime)

    const [visibleModalConfirmation, setVisibleModalConfirmation] = useState(false)
    const [visibleModalAddTime, setVisibleModalAddTime] = useState(false)
    const [visibleModalWebhook, setVisibleModalWebhook] = useState(false)
    const dispatch = useDispatch()



    const [visibleMenu, setVisibleMenu] = useState(false)

    const closeMenu = (event) => {
        setVisibleMenu(false)
    };

    useEffect(() => {

        if (visibleMenu) {
            window.addEventListener('click', closeMenu);
            // cleanup this component
            return () => {
                window.removeEventListener('click', closeMenu);
            };
        }

    }, [visibleMenu])


    const testeClick = () => {
        document.getElementById("myCheck").click();
    }


    // useEffect(() => {
    //    
    //     if (!statusDebug.loading && !statusDebug.error && statusDebug.data.length == 0) {
    //     } else {
    //         const id = "statusDebug"
    //         if (statusDebug.loading) {
    //             //toast.loading("Aguarde...", { toastId: id })
    //         } else {
    //             if (statusDebug.error) {
    //                 //toast.update(id, { render: "Erro ao tentar autenticar.", type: "error", isLoading: false, hideProgressBar: false, autoClose: 3000, closeOnClick: true });
    //             } else {
    //                 //toast.update(id, { render: "Autenticação feita com sucesso.", type: "success", isLoading: false, hideProgressBar: false, autoClose: 2000, closeOnClick: true })
    //                 setVisibleModalConfirmation(false)
    //                 window.open('https://app.lily.com.br/', '_blank');
    //             }
    //         }
    //     }
    // }, [statusDebug])

    // useEffect(() => {

    //     console.log("teste statusDebug", props.item.chave_empreender, statusDebug)

    //     if (statusDebug.loading == false && statusDebug.error == false && statusDebug.data.length == 0) {
    //         console.log("statusDebug default")

    //     } else {
    //         const id = "statusDebug"
    //         console.log("statusDebug não é default")
    //         if (statusDebug.loading == true) {
    //             setVisibleModalConfirmation(false)
    //             toast.loading("Aguarde...", { toastId: id })

    //         } else {
    //             if (statusDebug.error == true) {
    //                 toast.update(id, { render: "Entrando.", type: "success", isLoading: false, hideProgressBar: false, autoClose: 2000, closeOnClick: true })
    //             } else {
    //                 toast.update(id, { render: "Error.", type: "error", isLoading: false, hideProgressBar: false, autoClose: 2000, closeOnClick: true })
    //                 window.open(process.env.REACT_APP_URL, '_blank');
    //             }
    //         }
    //     }
    // }, [statusDebug])

    const statusDeleteCard = useSelector(state => state.reducerAdminDeleteCard)
    useEffect(() => {
        if (!(statusDeleteCard.loading == false && !statusDeleteCard.error == false && statusDeleteCard.data.length == 0)) {
            const id = "statusDeleteCard"
            if (statusDeleteCard.loading) {
                toast.loading("Aguarde...", { toastId: id })
            } else {
                if (statusDeleteCard.error) toast.update(id, { render: "Erro ao tentar excluir.", type: "error", isLoading: false, hideProgressBar: false, autoClose: 3000, closeOnClick: true });
                else {
                    toast.update(id, { render: "Excluído com sucesso.", type: "success", isLoading: false, hideProgressBar: false, autoClose: 2000, closeOnClick: true })
                    setVisibleModalConfirmation(false)
                }
            }
        }
    }, [statusDeleteCard])

    useEffect(() => {


        if (!(statusAddTime?.loading == false && !statusAddTime?.error == false && statusAddTime?.data.length == 0)) {
            const id = "statusAddTime"
            if (statusAddTime?.loading) {
                toast.loading("Aguarde...", { toastId: id })
            } else {
                if (statusAddTime?.error) toast.update(id, { render: "Erro ao tentar modificar tempo de acesso.", type: "error", isLoading: false, hideProgressBar: false, autoClose: 3000, closeOnClick: true });
                else {
                    toast.update(id, { render: "Modificado com sucesso.", type: "success", isLoading: false, hideProgressBar: false, autoClose: 2000, closeOnClick: true })
                    setVisibleModalAddTime(false)
                    //document.location.reload(true)
                }
            }
        }
    }, [statusAddTime])


    const goDebug = (item) => {

        dispatch({
            type: "SAGA_DEBUG_ADMIN", payload: {
                id: item.id
            }
        })
    }

    const addTimeUser = (qtd, type) => {



        dispatch({
            type: "SAGA_ADD_TIME_ADMIN", payload: {
                id: props.item.id,
                days: type == "days" ? parseInt(qtd) : 0,
                months: type == "months" ? parseInt(qtd) : 0
            }
        })
    }

    const whatsappCustom = (text) => {
        //(99) 9.9999-9999 e +55 (99) 99999999
        if (text) {
            let result = text?.length == 13 ?
                `+${text.slice(0, 2)} (${text.slice(2, 4)}) ${text.slice(4, 5)}.${text.slice(5, 9)}-${text.slice(9, 13)}` :
                text?.length == 10 ? `+55 (${text.slice(0, 2)}) ${text.slice(2, 6)}-${text.slice(6, 10)}` :
                    text?.length == 11 ? `+55 (${text.slice(0, 2)}) ${text.slice(2, 3)}.${text.slice(3, 7)}-${text.slice(7, 11)}` :
                        `+${text.slice(0, 2)} (${text.slice(2, 4)}) ${text.slice(4, 8)}-${text.slice(8, 12)}`
            return result
        }

        return '';
    }

    const deleteCard = () => {
        //alert("Em desenvolvimento!")
        dispatch({
            type: "SAGA_DELETE_CARD_ADMIN",
            payload: { id: props.item.id }
        })
    }

    const verifyWebhook = () => {
        //alert("Em desenvolvimento!")

        dispatch({
            type: "SAGA_VERIFY_WEBHOOK_CARD_ADMIN",
            payload: { id: props.item.id }
        })
    }

    const getPlatform = (platform) => {


        let platformNew = platform?.toLowerCase()

        switch (platformNew) {
            case "shopify":
                return <img src={IconShopify} onClick={() => { window.open(`${props.item?.url}`) }} />
            case "nuvemshop":
                return <img src={IconNuvemshop} onClick={() => { window.open(`https://${props.item?.url}`) }} />
            case "yampi":
                return <img src={IconYampi} onClick={() => { window.open(`${props.item?.url}`) }} />
            default:
                return null
        }
    }


    const getStatusAccount = (value) => {

        if (value == 0) {
            return "gray"
        } else if (new Date(value) > new Date()) {
            return "green"
        } else {
            return "red"
        }

    }



    const copy = () => {
        navigator.clipboard.writeText(props.item?.whatsapp)
        //setCopyKey(text)
        toast.success("Copiado")
    }

    const clickIntegration = () => {
        console.log("props.item.platform.toLowerCase()", props.item.platform.toLowerCase())
        switch (props.item.platform.toLowerCase()) {
            case "shopify":
                window.open(`${props.item.url}`)
            case "nuvemshop":
                window.open(`https://${props.item.url}`)
            case "yampi":
                window.open(`${props.item.url}`)
            default:
                window.open(`https://${props.item.url}`)
        }
    }

    return (
        <tr key={props.item.id} id="myCheck">
            <th>
                <div style={{ display: "flex", justifyContent: "center", }}>
                    {props.item.id}
                </div>
            </th>
            <th style={{ display: "flex", alignItems: "center", textAlign: "left", paddingLeft: "10px" }}>
                {props.item.name}
                [{props.item.chave_empreender}]
                <BoxIcon style={{ display: "flex", height: "40px" }}>
                    {getPlatform(props.item.platform)}
                    {props.item?.dropi == "dropi" && <img onClick={() => { clickIntegration() }} src={IconDropi} />}
                </BoxIcon>
            </th>
            <th >
                <a style={{ color: "#5e6278", marginRight: "10px" }} target="_blank" href={`https://wa.me/+${props.item.whatsapp?.length == 10 ? "55" + props.item?.whatsapp : props.item.whatsapp?.length == 11 ? "55" + props.item?.whatsapp : props.item?.whatsapp}`}>
                    {whatsappCustom(props.item?.whatsapp)}
                </a>
                {props.item?.whatsapp?.length > 0 && <MdOutlineContentCopy onClick={() => { copy() }} style={{ cursor: "pointer" }} size={24} color="gray" />}
            </th>
            <th>{new Date(props.item.created_at).toLocaleString()}</th>
            <th style={{ color: getStatusAccount(props.item.cred_expire * 1000) }}>{props.item.cred_expire == 0 ? new Date(new Date(props.item.created_at).setDate(new Date(props.item.created_at).getDate() + (props.item.affiliate == null ? 3 : 10))).toLocaleString() + " (Trial)" : new Date(props.item.cred_expire * 1000).toLocaleString()}</th>
            <th>{props.item.email}</th>
            {/* <th>
                <div style={{ display: "flex", justifyContent: "center", }}>
                    {props.item.inter_pay?.length == 0 || props.item.inter_pay == null ?
                        <ButtonCustom onClick={() => { setVisibleModalConfirmation(false) }} background={"#F1416C50"} color={"gray"} >Remover </ButtonCustom> :
                        <ButtonCustom onClick={() => { setVisibleModalConfirmation(true) }} active={true} background={"#F1416C"} color={"white"} >Remover </ButtonCustom>}
                </div>
            </th> */}
            <th style={{ display: "flex", justifyContent: "center" }}>

                <ActionsDropdown onClick={() => { setVisibleMenu(true) }} visible={visibleMenu}>
                    <label>Ações</label>
                    <div>
                        <label onClick={() => { goDebug(props.item) }} >Debug</label>
                        <label onClick={() => { setVisibleModalAddTime(true) }} >Conta</label>
                        <label onClick={() => { setVisibleModalWebhook(true); verifyWebhook() }} >Webhook</label>
                    </div>
                </ActionsDropdown>

                {/* <ButtonCustom onClick={() => { goDebug(props.item) }} background={"#19B674"} color={"white"} active={true}                                   >
                    Debug
                </ButtonCustom>
                <ButtonCustom onClick={() => { setVisibleModalAddTime(true) }} background={"#282876"} color={"white"} active={true}                                   >
                    Conta
                </ButtonCustom>
                <ButtonCustom type="button" disabled onClick={() => { alert("Teste") }} background={"#FFC16350"} color={"#29292950"} active={false}                                   >
                    Script
                </ButtonCustom>

                {props.item?.dropi == "dropi" && getPlatform(props.item.platform) !== null ?
                    <ButtonCustom type="button" active={true} onClick={() => { scriptDropi() }} background={"#182390"} color={"white"} >
                        {statusDropi.loading && statusDropi.data == props.item.id ?
                            <AiOutlineLoading size={15} color={"white"} /> :
                            "Dropi"}
                    </ButtonCustom> :
                    <ButtonCustom type="button" disabled active={false} background={"#18239050"} color={"white"} >Dropi </ButtonCustom>} */}


                {/* <ButtonCustom type="button" onClick={() => { scriptDropi(props.item.platform_id) }} background={"#182390"} color={"white"} disabled={props.item?.dropi == "dropi" ? true : false} active={props.item?.dropi == "dropi" ? true : false}                                   >
                    {statusDropi.loading && statusDropi.data == props.item.id ?
                        <AiOutlineLoading size={15} color={"white"} /> :
                        "dropi"}
                </ButtonCustom> */}

            </th>
            {/* <ConfirmationDelete
                confirmation={deleteCard}
                visible={visibleModalConfirmation}
                setVisibleModal={setVisibleModalConfirmation}
                title={"Deseja excluir esse cartão?"}
            /> */}
            <ModalAddTime
                visible={visibleModalAddTime}
                setVisibleModal={setVisibleModalAddTime}
                addTimeUser={addTimeUser}
                item={props.item}
            />

            <ModalWebhook
                visible={visibleModalWebhook}
                setVisibleModal={setVisibleModalWebhook}
                item={props.item}
            />



        </tr>
    )
}

export default CardNew
